
import  request  from '../../Interceptor/request.js'

//意见反馈
export function opinion(data) {
    return request({
        url: '/advice',
        method: 'post',
        data:data
    })
}

